export const get_categories = (state) => state.categories;

export const get_rewards = (state) => state.rewards;

export const get_reward = (state) => state.reward;
